<template>
  <div :class="['image-container', slice.sliceLabel]">
    <img class="image" :src="imageSrc">
  </div>
</template>

<script>
  import Slice from 'mixins/slice';
  import get from 'lodash.get';
  export default {
    name: 'ImageSlice',
    mixins: [Slice],
    computed: {
      imageSrc () {
        return get(this.slice, 'primary.image.url', null);
      }
    }

  };
</script>

<style lang="stylus" scoped>
  @require '~global/breakpoints'

  .image
    max-width: 100%

  .logo
    display: flex
    flex-direction: column
    align-items: center

    .image
      width: 60vw
      max-width: 800px
      margin-bottom: 4rem

  @media (max-width: $tablet)
    .logo .image
      width: 70vw

  @media (max-width: $mobile)
    .logo .image
      width: 80vw
</style>
